module.exports = __webpack_public_path__ + "img/img-1.c3d6c554.jpg";